import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/settings/$siteId/reporting")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <table>
      <thead>
        <tr>
          <th>Feature</th>
          <th>Description</th>
          <th>Notes</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Activate Google Analytics UTM tracking</td>
          <td>Adds UTM tags to links</td>
          <td>Should be a global toggle at account level</td>
        </tr>
      </tbody>
    </table>
  );
}
